import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

export default function Support() {
  const { t } = useTranslation();

  const supportOptions = [
    {
      title: t("support_documentation"),
      description: t("support_documentation_desc"),
      kicker: "Docs",
      link: "/docs",
    },
    {
      title: t("support_forum"),
      description: t("support_forum_desc"),
      kicker: "Hub",
      link: "/Resources",
    },
    {
      title: t("support_videos"),
      description: t("support_videos_desc"),
      kicker: "Blog",
      link: "/Blog",
    },
    {
      title: t("support_contact"),
      description: t("support_contact_desc"),
      kicker: "Email",
      link: "/Contact",
    },
  ];

  const faqs = [
    { question: t("faq_q1"), answer: t("faq_a1") },
    { question: t("faq_q2"), answer: t("faq_a2") },
    { question: t("faq_q3"), answer: t("faq_a3") },
    { question: t("faq_q4"), answer: t("faq_a4") },
  ];

  return (
    <MarketingLayout>
      <div className="marketing-page-content support-page support-page--wide">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Help</p>
          <h1>{t("support_title")}</h1>
          <p className="page-lead">{t("support_subtitle")}</p>
        </header>

        <div className="support-options-grid">
          {supportOptions.map((option) => (
            <Link
              key={option.link}
              to={option.link}
              className="marketing-section-card support-option-card marketing-section-card--interactive"
            >
              <span className="marketing-kicker" aria-hidden>
                {option.kicker}
              </span>
              <h2 className="marketing-section-title">{option.title}</h2>
              <p className="marketing-section-text">{option.description}</p>
            </Link>
          ))}
        </div>

        <section className="marketing-section-card">
          <h2 className="marketing-section-title">{t("faq")}</h2>
          <div className="support-faq-list">
            {faqs.map((faq) => (
              <div key={faq.question} className="support-faq-item">
                <h3 className="support-faq-question">{faq.question}</h3>
                <p className="marketing-section-text">{faq.answer}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="marketing-section-card support-cta-block">
          <h2 className="marketing-section-title">{t("still_need_help")}</h2>
          <p className="marketing-section-text mb-4">{t("support_available")}</p>
          <div className="marketing-cta-row" style={{ marginTop: 0 }}>
            <Link to="/Contact" className="marketing-cta">
              {t("support_contact")}
            </Link>
            <Link to="/chatbot" className="marketing-cta marketing-cta--secondary">
              {t("live_chat")}
            </Link>
          </div>
        </section>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
